module.exports = __webpack_public_path__ + "static/york-college-bus-0f86920c4f52c4996aacc7d1d0301e14.jpg";